import type { YMaps } from '@cian/frontend-ymaps-components/es/types/ymaps';

import { MAP_MARGIN, TMapPlatform } from '../../constants/map';
import { PIN_OVERHANG_BOTTOM, PIN_OVERHANG_TOP } from './parts/MapPin';

/** Боковые поля на мобилке по замечанию дизайна (в общих полях карты было 8px). */
const MOBILE_SIDE_MARGIN = 24;

const [mobileTop, , mobileBottom] = MAP_MARGIN.mobile;

/**
 * Поля карты ЖК. Карта вписывает в вьюпорт якоря пинов, а лейбл торчит над якорем на PIN_OVERHANG_TOP,
 * поэтому на мобилке к базовым полям добавляем вынос пина — иначе верхний лейбл режется краем экрана.
 * Десктопных 56px уже хватает. Ширину лейбла (до 180px) по бокам не резервируем: карта отзумилась бы слишком далеко.
 */
export const NEWBUILDINGS_MAP_MARGIN: Record<TMapPlatform, YMaps.Margin> = {
  desktop: MAP_MARGIN.desktop,
  mobile: [mobileTop + PIN_OVERHANG_TOP, MOBILE_SIDE_MARGIN, mobileBottom + PIN_OVERHANG_BOTTOM, MOBILE_SIDE_MARGIN],
};
